
import {
  Component,
  Vue
  // Prop,
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import { objAny } from "../../common/common-interface";
@Component
export default class SysContentHeader extends Vue {
  // @State sys: objAny;
  @State("sys") sys!: objAny;
  // @Mutation("UP_GOROUTER") UP_GOROUTER: (index: number) => void;
  @Mutation("UP_GOROUTER") UP_GOROUTER!: Function;

  public handleClose(item: objAny, index: number): void {
    if (this.sys.toData.path == item.url) {
      let url = "";
      if (index === 0) {
        url = this.sys.goRouter[index + 1].url;
      } else {
        url = this.sys.goRouter[index - 1].url;
      }
      this.$router.push(url);
    }
    this.UP_GOROUTER(index);
  }
  public tagClick(item: objAny) {
    console.log(item);
    this.$router.push(item.url);
  }
  // mounted() {}
}
